import { getLoggedUser } from "../../../utils/helpers/tokenStorage";

const setLastValue = (value: string, isCampaignList: boolean) => {  
  const user = getLoggedUser();
  localStorage.setItem(
    "lastSelectedCategoryValue" + user?.user?.user?.userId + (isCampaignList ? 'campaign' : 'delivery'),
    value
  );
};

export default setLastValue;
